import React, { useState, useEffect } from 'react';
import '../App.css';
import { useLocation } from 'react-router-dom';
import LoaderImg from '../img/logo/running.gif';
import axios from '../axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventSucessPopup from "../Create_event_details/EventSucessPopup";


const Integration = (props) => {
// console.log(props);
    const { state } = useLocation();
    const EditEventId = state ? state.eventId : 0;
    const [Loader, setLoader] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [successMsg, setsuccessMsg] = useState('Event created successfully');
    const [TcsPopup, setTcsPopup] = React.useState(false);

    const [TermsAndConditionsError, setTermsAndConditionsError] = useState('');
    const [TermsAndConditions, setTermsAndConditions] = useState(false);

    const [ContactPersonName, setContactPersonName] = useState('');
    const [SupportEmail, setSupportEmail] = useState('');
    const [SupportNumber, setSupportNumber] = useState('');
   
    const [SupportEmailError, setSupportEmailError] = useState('');
    const [SupportNumberError, setSupportNumberError] = useState('');

    const [embedTicketPopup, setembedTicketPopup] = useState("<button onclick='popup("+EditEventId+");' style='padding: 10px 16px; background-color: #d01c68; color: #fff; border-color: #d01c68;'>Register Now</button><noscript id='tsNoJsMsg'>Javascript on your browser is not enabled.</noscript><script src='https://passilo.com/public/assets/js/popup_scripts.js' type='text/javascript'></script>");
   
    const [embedTicketIframe, setembedTicketIframe] = useState('<iframe id="ts-iframe" src="https://passilo.com/public/ticket_iframe.html?'+EditEventId+'" frameborder="1" height="600" width="80%"></iframe><link rel="stylesheet" href = "https://passilo.com/static/Bookingflow/css/ts-iframe.style.css" >');

    
    const handleValidation = (e) => {
   
      var flag = true;
      
      // if (SupportEmail == "") {
      //     setSupportEmailError("Please enter support email address");
      //     flag = false;
      // }else
      
      if (SupportEmail != "" && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(SupportEmail))) {
          setSupportEmailError('Please enter a valid support email address');
          flag = false;
      }else{
         setSupportEmailError("");
      }

      // if (SupportNumber == "") {
      //     setSupportNumberError("Please enter support number");
      //     flag = false;
      // }else 
      if (SupportNumber != "" && SupportNumber.length < 10) {
          setSupportNumberError("Please enter valid support number");
          flag = false;
      }else{
          setSupportNumberError("");
      }

      // if (TermsAndConditions === false) {
      //   setTermsAndConditionsError("Accept TCS terms of services");
      //   flag = false;
      // } 

      // if(flag == true){
      //   setTermsAndConditionsError("");
      //   setTcsPopup(false);
      //   setOpen(true);
      // }

      return flag;
    }

    //console.log(props.EventTcsPopupFlag);
    const handleSubmit = (e) => {
      e.preventDefault();
        
      const flag = handleValidation();
      if (flag) {
        // if(props.EventTcsPopupFlag === 0){
            setLoader(true);
            const payload = {
              module_name: "Support",
              event_id: EditEventId ? EditEventId : 0,
              popup_flag: 1,
              contact_person_name: ContactPersonName,
              support_email: SupportEmail,
              support_number: SupportNumber
            };
          // console.log(payload);
            axios.post("event_integration", payload)
              .then((response) => {
                setLoader(false);
                  //console.log(response);
                  if (response.status === 200) {
                    // toast.success(response.data.message)
                    // setsuccessMsg(response.data.message);
                    // setTcsPopup(true);
                     setOpen(true);
                  }
              })
              .catch(() => {
                // setLoader(false);
                console.log('error');
              });
        // }else{
        //   setOpen(true);
        // }
      }   
    };

    const handleCopy = () => {
      navigator.clipboard.writeText(embedTicketPopup);
    }  

    const handleCopy1 = () => {
      navigator.clipboard.writeText(embedTicketIframe);
    } 
    
    useEffect(() => {
      window.scrollTo(0, 0);
      setContactPersonName(props.EventData ? props.EventData.contact_person_name : '');
      setSupportEmail(props.EventData ? props.EventData.support_email : '');
      setSupportNumber(props.EventData ? props.EventData.support_number : '');
    }, [props]);

    useEffect(() => {
      const handleKeyPress = (event) => {
          if (event.key === "Escape") {
            setTcsPopup(false); 
          }
      };
      // Add event listener when the component mounts
      document.addEventListener("keydown", handleKeyPress);
      // Remove event listener when the component unmounts
      return () => {
          document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);

    return (
        <>
       
       {TcsPopup ?
         
            <div className="modal is-visible" data-animation="slideInUp">
              <div className="modal-dialog quickview__main--wrapper">
                <header className="modal-header quickview__header">
                  <button className="close-modal quickview__close--btn" onClick={(e) => { setTcsPopup(false); }} >✕</button>
                </header>
                <div className="quickview__inner">
                  <div className="row">
                    <div className="login__section">
                        <div className="login__section--inner">
                        <div className='p-5'>
                          <h3>What is TCS and how does TCS work?</h3>
                          <hr/>
                          <p>Starting 1st October 2018, every e-commerce operator has to collect TCS as per the GST regulations.</p>
                          <p><strong>What is TCS under GST?</strong></p>
                          <p>Tax Collected at Source (TCS) under GST means the tax collected by an e-commerce operator from the consideration received by it on behalf of the supplier of goods, or services who makes supplies through the operator’s online platform. TCS will be charged as a percentage on the net taxable supplies.</p>
                          <p><strong>What is meant by the “net value of taxable supplies”?</strong></p>
                          <p>The “net value of taxable supplies” means the aggregate value of taxable supplies of goods or services or both, made during any month by a registered supplier through such operator reduced by the aggregate value of taxable supplies returned to such supplier during the said month.&nbsp;</p>
                          <p><strong>What is the rate of TCS notified by the Government?</strong></p>
                          <p>Rate of TCS is 0.5% under each Act (i.e. the CGST Act, 2017, and the respective SGST Act / UTGST Act respectively) and the same is 1% under the IGST Act, 2017.&nbsp;</p>
                          <p><strong>Is every e-commerce operator required to collect tax on behalf of the actual supplier?</strong></p>
                          <p>Every e-commerce operator is required to collect tax where the supplier is supplying goods or services through e-commerce operators and consideration with respect to the supply is to be collected by the said e-commerce operator.</p>
                          <p><strong>How can actual suppliers/organizers claim credit for TCS?</strong></p>
                          <p>Based on the statement (FORM GSTR-8) filed by the e-commerce operator, the TCS would be credited to the electronic cash ledger of the actual supplier in the respective tax head. The said credit can be used at the time of discharge of tax liability by the actual supplier.</p>
                          <p>If the supplier is not able to use the amount lying in the said cash ledger, the actual supplier may claim a refund of the excess balance lying in his electronic cash ledger in accordance with the provisions contained in section 54(1) of the CGST Act, 2017</p>
                          <p><strong>How does passilo handle TCS collected?</strong></p>
                          <p>passilo files the TCS collected from the transaction under an Organizer’s account on a monthly basis. Total TCS collected for a month for an organizer is filed at one go.</p>
                       
                          
                          <p className='d-flex gap-3 align-items-center mt-3' style={{marginBottom: '5px'}}> <input type='checkbox' name='confirm' style={{width:'20px', height:'20px'}} value={TermsAndConditions} checked={TermsAndConditions} onChange={() => setTermsAndConditions(!TermsAndConditions)}/> I acknowledge the terms of services related to TCS.</p>
                          <small className='text-danger'>{TermsAndConditionsError}</small>
                        </div>
                        
                        <input type="submit" name="command" value="Save" className="continue__shipping--btn primary__btn border-radius-5" style={{float: 'right'}} onClick={(e) => handleValidation(e)} />
                  
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        ''
      }

       {open ? <EventSucessPopup setOpen={setOpen} successMsg={successMsg} EventName={props.EventName}/> : null}
       
        {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
       
        <div className="main checkout__mian">
            <form onSubmit={(e) => handleSubmit(e)} >
                <div className="checkout__content--step section__shipping--address ">
                  <div className="mb-5">
                    <div className="section__header checkout__section--header d-flex align-items-center justify-content-between mb-4">
                       <h2 className="section__header--title h3">Support</h2>
                    </div>
                  </div>

                  <div className="row mb-5 create-event-integration">
                    
                    <div className="col-sm-6 my-3 ">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            value={ContactPersonName}
                            onChange={(e) => { setContactPersonName(e.target.value) }}
                          />
                          <label>Contact Person Name</label>
                        </div>
                    </div>
                   {/* <span className="checkout__input--label__star">*</span> */}
                    <div className="col-sm-6 my-3 ">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            value={SupportEmail}
                            onChange={(e) => { setSupportEmail(e.target.value) }}
                          />
                          <label>Support Email</label>
                        </div>
                        <small className="text-danger">{SupportEmailError}</small>
                    </div>

                    <div className="col-sm-6 my-3 ">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            value={SupportNumber}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setSupportNumber(value);
                              }
                            }}
                            maxLength={10}
                          />
                          <label>Support Number</label>
                        </div>
                        <small className="text-danger">{SupportNumberError}</small>
                    </div>
                    

                {/* <div className="col-sm-12 mb-5">
                      <label className='pre-title'>
                          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-240 80-480l240-240 57 57-184 184 183 183-56 56Zm320 0-57-57 184-184-183-183 56-56 240 240-240 240Z"/></svg>
                          <strong> Embed Tickets on your website (Pop-up)</strong>
                        </label>
                      <p className='my-3'>To embed ticketing on your website which opens over the content on clicking a button, paste this HTML code</p>
                      
                      <pre onClick={handleCopy}>
                        <code>
                          {embedTicketPopup}
                        </code>
                      </pre>
                </div>

                <div className="col-sm-12 mb-5">

                    <label className='pre-title'>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-240 80-480l240-240 57 57-184 184 183 183-56 56Zm320 0-57-57 184-184-183-183 56-56 240 240-240 240Z"/></svg>
                          <strong> Embed Tickets on your website (iframe)</strong>
                        </label>
                      <p className='my-3'>To embed ticketing within the content on your website, paste this HTML code</p>

                      <pre onClick={handleCopy1}>
                        <code>
                          {embedTicketIframe}
                        </code>
                      </pre>
                      
                </div> */}
               

                </div>

                </div>
              
                <div className="checkout__content--step__footer d-flex align-items-center justify-content-end gap-4">
                    <div className="continue__shipping--btn secondary__btn border-radius-5" onClick={(e) => { props.setEventResponceTabs(9) }} style={{cursor:'pointer'}}>Back</div>
                    {/* <input type="button" name="command" value="Next (6/6)" className="continue__shipping--btn primary__btn border-radius-5"  /> onClick={(e) => handleSubmit(e)} onClick={(e) => {setTcsPopup(true); }}  */} 
                    <input type="submit" name="command" value="Save" className="continue__shipping--btn primary__btn border-radius-5" />
                </div>
            </form>
        </div>
        </>
    )
}

export default Integration